/**
 * Share URL button
 *
 * @version 	2025.08.13
 * @name    	CSlice\JS\Share_URL
 */

// TODO: remove DOMContentLoaded since we are using wp-scripts
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.share-url-button .wp-block-button__link').forEach((button) => {
		button.onclick = async (e) => {
			e.preventDefault();
			await navigator.clipboard.writeText(location.href);
			button.textContent = 'Link Copied!';
		};
	});
});
